import React from "react";
import { SteelGrade, useCreateLoadMutation } from "src/store/api/generatedApi";
import { useTenant } from "hooks/settings";
import { ChangeCommentHistoryIcon } from "components/crane/supervisor/ChangeCommentHistoryIcon";
import { useMixChangeComments } from "components/crane/supervisor/useMixChangeComments";
import { BaseSteelGradesCell } from "./BaseSteelGradesCell";

interface Props {
  planId: number;
  mixId: number;
  steelGrades: SteelGrade[];
  selectedSteelGradeIds: number[];
  description?: string;
}

export const SupervisorSteelGradesCell = ({
  planId,
  mixId,
  steelGrades,
  selectedSteelGradeIds,
  description,
}: Props) => {
  const tenantName = useTenant();
  const [doCreateLoadMutation] = useCreateLoadMutation();
  const handleOnClick = React.useCallback(
    async (steelGradeId: number) => {
      await doCreateLoadMutation({
        tenantName,
        loadCreate: {
          steel_grade_id: steelGradeId,
          plan_id: planId,
          mix_id: mixId,
        },
      });
    },
    [mixId, planId, doCreateLoadMutation, tenantName]
  );

  const { comments } = useMixChangeComments(planId, mixId);

  const latestComment = comments.length > 0 ? comments[0]?.comment : undefined;
  const combinedDescription =
    latestComment !== undefined
      ? description
        ? `${description} | ${latestComment}`
        : latestComment
      : description;

  return (
    <BaseSteelGradesCell
      onClick={(steelGradeId) => void handleOnClick(steelGradeId)}
      steelGrades={steelGrades}
      selectedSteelGradeIds={selectedSteelGradeIds}
      description={combinedDescription}
      descriptionEndAdornment={
        comments.length > 0 ? (
          <ChangeCommentHistoryIcon comments={comments} />
        ) : undefined
      }
    />
  );
};
